import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import PersonalityQuizBasicModel from "./PersonalityQuizBasicModel";

export default class PersonalityQuizzesModel {
  public meta: MetaModel = new MetaModel();
  public data: PersonalityQuizBasicModel[] = [];
}
